<template>
    <div class="row p-3">
      <div class="col-12 col-xl-4 text-semibold">
        <div class="row">
          <div class="col d-flex align-items-center">
            <p class="strong text-truncate">{{ item.name }}</p>
          </div>
        </div><!-- /.row -->
      </div>
      <div class="col-4 col-xl-4">
        <p class="text-truncate">
          <span class="data-label d-lg-none">Media Owner</span>
          {{ item.owner ? item.owner.name : '-' }}
        </p>
      </div>
      <div class="col-xl-1 offset-xl-2">
        <button type="button" class="btn btn-sm text-warning" @click="handleArchive(item)">
          <i class="far fa-trash-restore" v-if="item.archived"></i>
          <i class="far fa-archive" v-else></i>
        </button>
      </div>
    </div>
</template>

<script>
import { helperMethods } from '@/vuex/modules/settings/media-owner-screen-tags'
export default {
  props: {
    item: {
      required: true,
      type: Object
    }
  },
  methods: {
    ...helperMethods,
    async handleArchive (item) {
      if (item.archived) {
        await this.updateMediaOwnerScreenTag(item)
        this.resetMediaOwnerScreenTag()
        this.getMediaOwnerScreenTags({ fresh: true })
      } else {
        await this.deleteMediaOwnerScreenTag(item.id)
        await this.getMediaOwnerScreenTags({ fresh: true })
      }
    }
  }
}
</script>
